import type { RootState } from '../../../../store';

//map interface
export const selectEmissionsMapInterface = (state: RootState) => state.pages.emissions.mapInterface;

// map name
export const selectEmissionsMapName = (state: RootState) => selectEmissionsMapInterface(state).mapName;

export const selectL4MSATColorScale = (state: RootState) => selectEmissionsMapInterface(state).l4MSATColorScale;

export const selectMapInterfaceUI = (state: RootState) => selectEmissionsMapInterface(state).ui;

export const selectIsAnyChipExpanded = (state: RootState) => {
    const ui = selectMapInterfaceUI(state);

    // check for any chip that includes 'Expanded' in its key
    return Object.entries(ui)
        .filter(([key]) => key.includes('Expanded'))
        .some(([_, value]) => Boolean(value));
};
